var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18V23H6",
    stroke: "#ADC8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1H1V6",
    stroke: "#ADC8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1H23V6",
    stroke: "#ADC8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H23V18",
    stroke: "#ADC8FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 8C15.9375 10.2091 14.1746 12 12 12C9.82538 12 8.0625 10.2091 8.0625 8C8.0625 5.79086 9.82538 4 12 4C14.1746 4 15.9375 5.79086 15.9375 8Z",
    fill: "#004FEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3704C5 17.1299 5 16.5096 5.15071 16.0049C5.49003 14.8686 6.3654 13.9793 7.484 13.6346C7.98082 13.4815 8.59138 13.4815 9.8125 13.4815H14.1875C15.4086 13.4815 16.0192 13.4815 16.516 13.6346C17.6346 13.9793 18.51 14.8686 18.8493 16.0049C19 16.5096 19 17.1299 19 18.3703V18.3704C19 18.7839 19 18.9906 18.9498 19.1589C18.8367 19.5376 18.5449 19.8341 18.172 19.949C18.0064 20 17.8029 20 17.3959 20H17.3958H6.60417H6.60412C6.19711 20 5.9936 20 5.828 19.949C5.45513 19.8341 5.16334 19.5376 5.05024 19.1589C5 18.9906 5 18.7839 5 18.3704Z",
    fill: "#004FEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLink);
export default __webpack_public_path__ + "static/media/app-link.c5e81db0a7abb092a16798fca3b43fa3.svg";
export { ForwardRef as ReactComponent };